export const spherePoints = (count) => Array.from({ length: count }, (_, index) => {
  const y = 1 - (2 * (index + 0.5)) / count;
  const radius = Math.sqrt(1 - y * y);
  const angle = index * Math.PI * (3 - Math.sqrt(5));
  return { x: Math.cos(angle) * radius, y, z: Math.sin(angle) * radius };
});

export const rotatePoint = ({ x, y, z }, yaw, pitch) => {
  const horizontal = x * Math.cos(yaw) + z * Math.sin(yaw);
  const depth = z * Math.cos(yaw) - x * Math.sin(yaw);
  return {
    x: horizontal,
    y: y * Math.cos(pitch) - depth * Math.sin(pitch),
    z: y * Math.sin(pitch) + depth * Math.cos(pitch),
  };
};
